import { shallowEqual, useSelector } from 'react-redux';
import { SpaceTab } from '../schema';
import { getSpaceTabsBySpaceId } from '../selectors';

export const useSpaceTabs = (spaceId: number): SpaceTab[] => {
  const spaceTabs = useSelector(getSpaceTabsBySpaceId(spaceId), shallowEqual);

  return [
    ...spaceTabs.filter((s) => s.spaceTabId > 0),
    ...spaceTabs.filter((s) => String(s.spaceTabId) === 'new'),
  ];
};
